'use strict';

function trimmedString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

/** A stored name may be "EVOWALK-Right-RL #6902". The suffix is not a label. */
function withoutMacSuffix(value) {
  const hash = value.indexOf('#');
  if (hash === -1) return value;
  return value.slice(0, hash).trim();
}

/** Visible label. Never the MAC, and never a " #…" suffix. */
export function evowalkLabel(device) {
  if (!device || typeof device !== 'object') return '';
  const advertised = trimmedString(device.advertised_name);
  const raw = advertised || trimmedString(device.name);
  if (!raw) return '';
  return withoutMacSuffix(raw);
}

/** A unit the system has never connected to. `known` matches the camera list. */
export function isNewEvowalkDevice(device) {
  if (!device || typeof device !== 'object') return false;
  return device.known === 'no' || device.known === false;
}

export function evowalkAddress(device) {
  if (!device || typeof device !== 'object') return '';
  return trimmedString(device.address);
}

/**
 * `name` is the label. `address` selects the unit when several share that label.
 * Address is omitted when blank; a single saved device can be addressed by name alone.
 */
export function evowalkActionQuery(name, address) {
  const params = new URLSearchParams();
  params.set('name', typeof name === 'string' ? name : '');
  const mac = trimmedString(address);
  if (mac) params.set('address', mac);
  return params.toString();
}

/** One entry per list item, including rows that share a label. */
export function evowalkDevicesFromList(res) {
  if (!res || typeof res !== 'object' || res.status !== 'success') return [];
  const devices = res.devices;
  const list = Array.isArray(devices)
    ? devices
    : (devices && typeof devices === 'object' ? Object.values(devices) : []);
  return list.filter((device) => device && typeof device === 'object');
}

export function evowalkRowKey(device, index) {
  const address = evowalkAddress(device);
  if (address) return address;
  return `row-${index}`;
}
